import Big from 'big.js';

export function initBigJs() {
  // https://talostrading.atlassian.net/browse/UI-4092
  // Effectively deprecate toString and replace it with toFixed
  Big.prototype.toString = Big.prototype.toFixed;
}
